// extracted by mini-css-extract-plugin
export default {"prizeWrapper":"Prizes_prizeWrapper__xGqZ2","amountWrapper":"Prizes_amountWrapper__1QucB","first":"Prizes_first__t5xvH","second":"Prizes_second__kdNJW"};